import {
    ADD_CATEGORIAS, 
    ORDENA_STATE_A_Z, 
    ORDENA_STATE_Z_A
} from './mutation-types'

export default {
    [ADD_CATEGORIAS](state, payload) {
        state.categorias = state.categorias.concat(payload);
        state.buscouTodasAsCategorias = true;
    },
    [ORDENA_STATE_A_Z](state){
        state.ordenacaoDeAZ = true;
        let ordernaDeAZFunction = (categoria1, categoria2) => {
            return (categoria1.nome > categoria2.nome) ? 1 : ((categoria2.nome > categoria1.nome) ? -1 : 0);
        }
        state.categorias = state.categorias.sort(ordernaDeAZFunction)
    },
    [ORDENA_STATE_Z_A](state){
        state.ordenacaoDeAZ = false;
        let ordernaDeZAFunction = (categoria1, categoria2) => {
            return (categoria1.nome < categoria2.nome) ? 1 : ((categoria2.nome < categoria1.nome) ? -1 : 0);
        }
        state.categorias = state.categorias.sort(ordernaDeZAFunction)

    }
}